'use client';

import { c as _c } from "react/compiler-runtime";
import { APP_SHELL_LEFT_RAIL_CLASS } from '@/components/layout/dashboard/app-shell-left-rail';
import { LoadingStatus } from '@/comps/primitives/loading-status';
import { Skeleton } from '@/comps/primitives/skeleton';
import { cn } from '@/utils/shad';
type AppShellRailSkeletonProps = {
  /** When true, wraps in a screen-reader loading announcement for standalone use. */
  standalone?: boolean;
};
export function AppShellRailSkeleton(t0) {
  const $ = _c(9);
  const {
    standalone: t1
  } = t0;
  const standalone = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn(APP_SHELL_LEFT_RAIL_CLASS, "flex h-full flex-col overflow-hidden border-r bg-muted/30");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex shrink-0 flex-col items-stretch gap-1 py-0"><div className="flex w-full flex-col items-center gap-[3px] pt-2"><Skeleton className="size-[34px] rounded-[10px]" /><div aria-hidden={true} className="h-[11px] w-10" /></div></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex shrink-0 flex-col items-stretch gap-1 py-2"><div className="flex w-full flex-col items-center gap-0.5 py-1.5"><Skeleton className="h-7 w-[34px] rounded-lg" /><div aria-hidden={true} className="h-[11px] w-8" /></div></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="min-h-0 grow" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex min-h-0 flex-1 flex-col">{t5}<div className="flex shrink-0 flex-col items-stretch gap-1 py-2"><div className="flex w-full flex-col items-center gap-0.5 py-1.5"><Skeleton className="h-7 w-[34px] rounded-lg" /><div className="h-[11px] w-8" /></div></div></div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-px bg-border" />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <aside aria-hidden={true} className={t2}>{t3}{t4}{t6}<div className="shrink-0">{t7}<div className="flex flex-col items-center gap-1 py-2"><Skeleton className="size-8 rounded-lg" /><Skeleton className="size-8 rounded-lg" /><Skeleton className="size-8 rounded-lg" /></div></div></aside>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const rail = t8;
  let t9;
  if ($[7] !== standalone) {
    t9 = standalone ? <LoadingStatus>{rail}</LoadingStatus> : rail;
    $[7] = standalone;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  return t9;
}